import { useState, useEffect } from 'react';
import { SalesHistoryPage } from './seller/SalesHistoryPage';
import { DesktopSalesHistoryPage } from './desktop/DesktopSalesHistoryPage';

export function ResponsiveSalesHistoryPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <SalesHistoryPage /> : <DesktopSalesHistoryPage />;
}